// extracted by mini-css-extract-plugin
export default {"addDeleteButtonContainer":"CreateTemplateTab_addDeleteButtonContainer__C2YVh"};